export const GET_COUNTRIES_PREFIX = 'GET_COUNTRIES_PREFIX';
export const GET_COUNTRIES_PREFIX_SUCCESS = 'GET_COUNTRIES_PREFIX_SUCCESS';
export const GET_COUNTRIES_PREFIX_ERROR = 'GET_COUNTRIES_PREFIX_ERROR';

export const getCountriesPrefix = () => ({
  type: GET_COUNTRIES_PREFIX,
});
